import AuthService from '@/services/AuthService';
import RelationshipService from '@/services/RelationshipService';

function isValidUrl(url) {
	const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
	return urlRegex.test(url);
}

const state = () => ({
    username: '',
    userimage: '',
    userid:'',
    openMenu:'',
    unPaidRegistration: false,
    imageProfile: '',
    languageId: '',
    languageCode: '',
    languages: [],
    user: null,
    age18: false,
    hasUnsignedWaiver: null,
    spectatorRole: null,
    participantRole: null,
    roles: [],
    participants: [],
    participantsSelected: [],
    loadingPage: false,
    hideWaiversMenu: false
});

const mutations = { 
    setUserName(state, username) {
        state.username = username
    },
    setUserImg(state, userimage) {
        state.userimage = userimage
    },
    setOpenMenu(state, openmenu) {
        state.openmenu = openmenu
    },
    setUserId(state, userid) {
        state.userid = userid
    },
    setUnPaidRegistration(state, value) {
        state.unPaidRegistration = value
    },
    setImageProfile(state, value) {
        state.imageProfile = value
    },
    setLanguageId(state, value) {
        state.languageId = value
    },
    setLanguageCode(state, value) {
        state.languageCode = value
    },
    setLanguages(state, value) {
        state.languages = value
    },
    setUser(state, value) {
        state.user = value;
        if(!value) return;
        if(state.participants.length == 0) {
            state.participants.push({
                id: value.id,
                names: value.firstName+" "+value.lastName,
                image: value.image,
                userId: value.id
            }); 
        } else {
            state.participants[0] = {
                id: value.id,
                names: value.firstName+" "+value.lastName,
                image: value.image,
                userId: value.id
            };
        }
    },
    setAge18(state, value) {
        state.age18 = value;
    },
    setHasUnsignedWaiver(state, value) {
        state.hasUnsignedWaiver = value;
    },
    setSpectatorRole(state, value) {
        state.spectatorRole = value;
    },
    setParticipantRole(state, value) {
        state.participantRole = value;
    },
    setRoles(state, value) {
        state.roles = value;
    },
    setParticipants(state, value) {
        state.participants = value;
    },
    setParticipantsSelected(state, value) {
        const list = Array.isArray(value) ? value : [];
        const participants = state.participants || [];
        state.participantsSelected = list.map((p) => {
            const full = participants.find((x) => Number(x?.userId || x?.id) === Number(p?.userId || p?.id));
            const accountManagerUserId = p?.accountManagerUserId ?? full?.accountManagerUserId ?? full?.fkUsersIdMaster;
            return { ...p, accountManagerUserId };
        });
    },
    setLoadingPage(state, value) {
        state.loadingPage = value;
    },
    setHideWaiversMenu(state, value) {
        state.hideWaiversMenu = value;
    }
}

const getters = {
    username: (state) => state.username,
    userimage: (state) => state.userimage,
    openmenu: (state) => state.openmenu,
    userid: (state) => state.userid,
    unPaidRegistration: (state) => state.unPaidRegistration,
    imageProfile: (state) => state.imageProfile,
    languageId: (state) => state.languageId,
    languageCode: (state) => state.languageCode,
    languages: (state) => state.languages,
    user: (state) => state.user,
    age18: (state) => state.age18,
    hasUnsignedWaiver: (state) => state.hasUnsignedWaiver,
    spectatorRole: (state) => state.spectatorRole,
    participantRole: (state) => state.participantRole,
    roles: (state) => state.roles,
    participants: (state) => state.participants,
    participantsSelected: (state) => state.participantsSelected,
    loadingPage: (state) => state.loadingPage,
    hideWaiversMenu: (state) => state.hideWaiversMenu
}

const actions = {
    async setUserNameAction(context, username) {
        context.commit('setUserName', username)
    },
    async setUnPaidRegistration(context, unPaidRegistration) {
        context.commit('setUnPaidRegistration', unPaidRegistration)
    },
    async setUserImgAction(context, userimage) {   
        context.commit('setUserImg', userimage)
    },
    async setOpenMenuAction(context, openmenu) {   
        context.commit('setOpenMenu', openmenu)
    },
    async setUserIdAction(context, userid) {   
        context.commit('setUserId', userid)
    },
    async setUnPaidRegistrationAction(context, value) {   
        context.commit('setUnPaidRegistration', value)
    },
    async setImageProfile(context, value) {   
        context.commit('setImageProfile', value)
    },
    async setLanguageId(context, value) {   
        context.commit('setLanguageId', value)
    },
    async setLanguageCode(context, value) {   
        context.commit('setLanguageCode', value)
    },
    async setLanguages(context, value) {   
        context.commit('setLanguages', value)
    },
    async setUserValueAction(context, value) {
        context.commit('setUser', value)
    },
    async setUserAction(context, value = { forceUpdate: false, forceParticipants: false, disabledLoading: false }) { 
        let env = context.getters.env
        const { forceParticipants, disabledLoading } = value;
        return AuthService.getUserCurrent().then(response =>{
            if(response.data.success == 1) {
                const imgUser = response.data.message.existFile
                        ? isValidUrl(response.data.message.image) ? response.data.message.image : env.get('VUE_APP_DEV_API_HOST')+"/laravel/public" + response.data.message.image
                        : require("@/assets/images/partPlaceholder.jpg")
                        ? isValidUrl(response.data.message.image)  ? response.data.message.image : env.get('VUE_APP_DEV_API_HOST') + response.data.message.image
                        : require("@/assets/images/partPlaceholder.jpg");
                response.data.message.image = imgUser;
                context.commit('setUser', response.data.message)
                const nowDay = new Date();
                const birthdayCurrent = response.data.message.birthday;
                nowDay.setFullYear(nowDay.getFullYear() - 18);
                if(birthdayCurrent) {
                    const birthday = new Date(birthdayCurrent);
                    const cond = birthday <= nowDay;
                    context.commit('setAge18', cond)
                } else {
                    context.commit('setAge18', false);
                }
                if(forceParticipants) {
                    context.dispatch('setParticipantsAction');
                }
                if(disabledLoading) {
                    context.commit('setLoadingPage',false);
                }
            }
        }).catch(() => {
            if(disabledLoading) {
                context.commit('setLoadingPage',false);
            }
        });
    },
    async setUnsignedWaiver(context, value) {
        context.commit('setHasUnsignedWaiver', value)
    },
    async setAge18Action(context) {
        const user = context.state.user;
        if(!user)
            await context.dispatch('setUserAction');
        const nowDay = new Date();
        nowDay.setFullYear(nowDay.getFullYear() - 18);
        const birthdayCurrent = user ? user.birthday : false;
        if(birthdayCurrent) {
            const birthday = new Date(birthdayCurrent);
            context.commit('setAge18', birthday <= nowDay);
            return;
        }
        context.commit('setAge18', false);
    },
    async setSpectatorRoleAction(context, value) {
        context.commit('setSpectatorRole', value)
    },
    async setParticipantRoleAction(context, value) {
        context.commit('setParticipantRole', value)
    },
    async setRolesAction(context) {
        if((context.state.roles || []).length == 0) {
            RelationshipService.getUserRoles().then(response =>{
                if(response.data.success == 1){
                    response.data.message.forEach((item) => {
                        if(item.userRoleCode == 'Participant') {
                            context.commit('setParticipantRole', item);
                        }
                        if(item.userRoleCode == 'Spectator') {
                            context.commit('setSpectatorRole', item);
                        }
                    });
                    context.commit('setRoles', response.data.message);
                }
            }).catch(() => {
                context.commit('setRoles', []);
            });
        }
    },
    async setParticipantsAction(context) {
        const { state, getters, commit, dispatch } = context;
        let user = state.user;
        if(!user) {
            await dispatch('setUserAction');
            user = state.user;
        }
        let _participants = [];

        if (user) {
            _participants.push({
                id: user.id,
                names: `${user.firstName} ${user.lastName}`,
                image: user.image,
                userId: user.id,
                birthDate: user.birthday
            });
        }
    
        try {
            const response = await RelationshipService.getYourAccountManager();
    
            if (response.data.success === 1) {
                const env = getters.env;
                const currentUserId = user ? user.id : null;
                response.data.message.forEach((element) => {
                    _participants.push({
                        id: element.linkedMemberId,
                        names: element.fName+" "+element.lName,
                        image: element.existFile
                              ? env.get('VUE_APP_DEV_API_HOST')+"/laravel/public"+element.image 
                              : require("@/assets/images/partPlaceholder.jpg")
                              ? env.get('VUE_APP_DEV_API_HOST') + element.image
                              : require("@/assets/images/partPlaceholder.jpg"),
                        userId: element.userId,
                        birthDate: element.birthday,
                        accountManagerUserId: element.accountManagerUserId ?? element.fkUsersIdMaster ?? currentUserId
                    });
                });
            }
            
        } catch (error) {
            //console.error("Error", error);
        }
        
        commit('setParticipants', _participants); 
        
        dispatch('setParticipantsSelectedAction');
    },
    async setParticipantsActionOld(context) {
        const user = context.state.user;
        let _participants = [];
        if(user) {
            _participants.push({
              id: user.id,
              names: user.firstName+" "+user.lastName,
              image: user.image,
              userId: user.id,
              birthDate: user.birthday
            });
        } else {
            _participants.push(null)
        }
        await RelationshipService.getYourAccountManager().then(response => {
            if(response.data.success == 1){
              const currentUserId = context.state.user ? context.state.user.id : null;
              response.data.message.forEach((element) => {
                  let env = context.getters.env;
                  _participants.push({
                    id: element.linkedMemberId,
                    names: element.fName+" "+element.lName,
                    image: element.existFile
                          ? env.get('VUE_APP_DEV_API_HOST')+"/laravel/public"+element.image 
                          : require("@/assets/images/partPlaceholder.jpg")
                          ? env.get('VUE_APP_DEV_API_HOST') + element.image
                          : require("@/assets/images/partPlaceholder.jpg"),
                    userId: element.userId,
                    birthDate: element.birthday,
                    accountManagerUserId: element.accountManagerUserId ?? element.fkUsersIdMaster ?? currentUserId
                  });
              });
              context.commit('setParticipants', _participants);
            } else {
                context.commit('setParticipants', _participants);
            }
        });
        context.dispatch('setParticipantsSelectedAction');

    },
    async setParticipantsSelectedAction(context) {
        const user = context.state.user;
        const participants = context.state.participants || [];
        const isSameParticipant = (a, b) => {
            return (
                (a && b) &&
                ((a.userId && b.userId && a.userId == b.userId) ||
                (a.id && b.id && a.id == b.id) ||
                (a.id && b.userId && a.id == b.userId) ||
                (a.userId && b.id && a.userId == b.id))
            );
        };

        if(participants.length == 0) {
            context.commit('setParticipantsSelected', []);
            return;
        }

        const authParts = user ? AuthService.getAuthParticipants(user.id) : false;
        let participant = authParts ? participants.filter((el) => {
            const findAuth = authParts.find((ele) => isSameParticipant(ele, el));
            return !!findAuth;
        }) : [...participants];

        // Keep logged-in account selected even if stale local storage misses it.
        if(user) {
            const currentUserParticipant = participants.find((el) => {
                return isSameParticipant(user, el);
            });
            const existsInSelection = participant.find((el) => isSameParticipant(el, currentUserParticipant));
            if(currentUserParticipant && !existsInSelection) {
                participant.unshift(currentUserParticipant);
            }
        }

        const enriched = (participant || []).map((p) => {
            const fromAuth = authParts && Array.isArray(authParts) ? authParts.find((a) => Number(a?.userId || a?.id) === Number(p?.userId || p?.id)) : null;
            const accountManagerUserId = p?.accountManagerUserId ?? fromAuth?.accountManagerUserId ?? p?.fkUsersIdMaster;
            return { ...p, accountManagerUserId };
        });
        context.commit('setParticipantsSelected', enriched);
    }   ,
    async setLoadingPageAction(context,value) {
        context.commit('setLoadingPage', value)
    },
    async setHideWaiversMenuAction(context, value) {
        context.commit('setHideWaiversMenu', value)
    }
}

export default {
    state, mutations, actions, getters
}